import CommitmentImg from "src/assets/images/home/features/Commitment.svg";
import QualityImg from "src/assets/images/home/features/Quality.svg";
import MicroscopeImg from "src/assets/images/home/features/Microscope.svg";

interface FeatureType {
    img: string;
    title: {
        ar: string;
        en: string;
        it: string;
    };
    content: {
        ar: string;
        en: string;
        it: string;
    };
}

export const features: FeatureType[] = [
    {
        img: CommitmentImg,
        title: {
            ar: "الالتزام",
            en: "Commitment",
            it: "Impegno",
        },
        content: {
            ar: "نلتزم بالمواعيد والدقة في التنفيذ، ونسعى لتقديم خدمات موثوقة تلبّي احتياجات عملائنا بأقصى درجات المسؤولية.",
            en: "We are committed to punctuality and precision in execution, striving to deliver reliable services that meet our clients’ needs with the highest sense of responsibility.",
            it: "Ci impegniamo a rispettare le scadenze e la precisione nell'esecuzione, offrendo servizi affidabili che soddisfano le esigenze dei nostri clienti con la massima responsabilità.",
        },
    },
    {
        img: QualityImg,
        title: {
            ar: "الجودة",
            en: "Quality",
            it: "Qualità",
        },
        content: {
            ar: "نحرص على استيراد الأدوية من مصادر موثوقة ومعتمدة عالمياً، لضمان منتجات تلبي أعلى معايير السلامة والفعالية.",
            en: "We ensure that all medicines are imported from trusted and globally approved sources to guarantee products that meet the highest standards of safety and effectiveness.",
            it: "Ci assicuriamo che tutti i farmaci siano importati da fonti affidabili e approvate a livello globale, per garantire prodotti che rispettano i più alti standard di sicurezza ed efficacia.",
        },
    },
    {
        img: MicroscopeImg,
        title: {
            ar: "الاحترافية",
            en: "Professionalism",
            it: "Professionalità",
        },
        content: {
            ar: "نعتمد على كوادر مؤهلة وخبرة عالية في المجال لضمان تنفيذ الأعمال بكفاءة واحترافية عالية.",
            en: "We rely on qualified personnel with extensive experience to ensure that all tasks are carried out efficiently and professionally.",
            it: "Ci affidiamo a personale qualificato con grande esperienza per garantire che tutte le attività siano svolte in modo efficiente e professionale.",
        },
    },
];
